import useSWR, { type SWRConfiguration } from 'swr';
import { QueryKey } from '@/api/queryKey';
import { getAuthenticatedUser } from '@/api/user';
import { useFirebaseUser } from '@/hooks/useFirebaseUser';

export const useAuthenticatedUser = (config?: SWRConfiguration) => {
  const firebaseUser = useFirebaseUser();
  const shouldFetch = firebaseUser !== null && firebaseUser !== undefined;

  const { data, isLoading, isValidating, error, mutate } = useSWR(
    () => (shouldFetch ? QueryKey.GetAuthenticatedUser() : null),
    () => getAuthenticatedUser(),
    config
  );

  return {
    data: data ?? null,
    isLoading,
    isValidating,
    isReady: !isLoading && !isValidating && !error,
    error,
    mutate,
  };
};
